const vi = {
  menu: {
    about: { title: "GIỚI THIỆU" },
    products: {
      title: "SẢN PHẨM",
      tea: "Trà",
      coffee: "Cà phê",
      agricultural: "Nông sản",
      energyDrink: "Nước tăng lực",
      juice: "Nước ép ổi hồng",
      oil: "Dầu ăn",
    },
    promotion: { title: "Ưu đãi" },
    news: {
      title: "TIN TỨC",
      newsTea: "Tin tức trà",
      newsCoffee: "Tin tức cà phê",
      newsAgri: "Tin tức nông sản",
    },
    noidia: { title: "NỘI ĐỊA" },
    xuatkhau: { title: "XUẤT KHẨU" },
    recruitment: { title: "Tuyển dụng" },
    muahang: { title: "MUA HÀNG" },
    contact: { title: "LIÊN HỆ" },
    search: { title: "Tìm kiếm" },
    profile: { title: "Hồ sơ" },
    language: { title: "Ngôn ngữ" },
  },
  footer: {
    addressLabel: "Địa chỉ liên hệ",
    customerPolicy: "CHÍNH SÁCH KHÁCH HÀNG",
    contactInfo: "THÔNG TIN LIÊN HỆ",
    factory: "NHÀ MÁY",
    followUs: "LIÊN HỆ VỚI CHÚNG TÔI",
    contactWith: "KẾT NỐI VỚI VIỆT THIÊN",
    payments: "Phương thức thanh toán",
    cod: "Thanh toán trực tiếp",
    bankTransfer: "Chuyển khoản",
    wallet: "Ví điện tử",
    info1: "GIấy CNĐKKD: 0305693542 - Ngày cấp 22/02/2008",
    info2: "Cơ quan cấp: Sở Kế Hoạch và Đầu Tư TP HCM.",
  },
  contact: {
    content:
      "Nếu bạn có bất kỳ thắc mắc hay mong muốn hợp tác, vui lòng để lại thông tin liên hệ chúng tôi sẽ hỗ trợ sớm nhất.",
    taxCodeLabel: "Mã số thuế",
    email: "Email",
    address: "Văn phòng",
    form: {
      title: "Liên hệ với chúng tôi",
      fullName: "Họ và tên",
      email: "Email",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      content: "Ý kiến",
      button: "Gửi thông tin",
      loading: "Đang gửi...",
    },
    placeholder: {
      fullName: "Họ và tên",
      email: "Địa chỉ email",
      phone: "Số điện thoại liên hệ",
      content: "Nhập nội dung ở đây...",
      address: "Địa chỉ liên hệ",
    },
    toast: {
      success: "Gửi thông tin thành công. Chúng tôi sẽ liên hệ sớm nhất.",
      error: "Gửi thông tin không thành công. Vui lòng thử lại sau.",
    },
    map: {
      title: "Danh sách nhà máy Việt Thiên",
    },
  },
  news_flow: {
    back_to_list: "Quay lại danh sách",
    no_results: "Không tìm thấy bài viết",
    editorial_board: "Ban biên tập",
    share: "Chia sẻ",
    related_news: "Tin tức liên quan",
    promo_title: "Ora Park App",
    promo_desc: "Tải ứng dụng Ora Park để cập nhật bảng giá và chính sách bán hàng mới nhất.",
    promo_btn: "Tải ứng dụng ngay",
    blog_title: "Tin tức & Sự kiện",
    blog_desc: "Cập nhật các thông tin, sự kiện và tiến độ dự án mới nhất",
    read_more: "Đọc chi tiết",
    categories: {
      company: "Tin tức Dragon Home",
    },
  },
};

export default vi;
